import { render, staticRenderFns } from "./CardScaffoldProjects.vue?vue&type=template&id=7df6c9f7"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df6c9f7')) {
      api.createRecord('7df6c9f7', component.options)
    } else {
      api.reload('7df6c9f7', component.options)
    }
    module.hot.accept("./CardScaffoldProjects.vue?vue&type=template&id=7df6c9f7", function () {
      api.rerender('7df6c9f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffoldProjects.vue"
export default component.exports